module.exports = __webpack_public_path__ + "static/media/21-5.97512c30.mp3";